import Editor from './editor';

const RoleManagement = {
  Editor,
};

export default RoleManagement;
